import {helpEvent} from '@sinclair-digital/stl-common/src/analytics/util';

export const helpIconClicked = (opts = {}) => helpEvent(true, 'helpIconClicked', opts);
